import Compare from './Compare'

const Tools = () => {
  return <Compare selectedSboms={null} />
}

export default Tools
